import React from "react";
import { InfoCircleFilled } from "@ant-design/icons";
import { Minus, Plus } from "lucide-react";
import { motion, AnimatePresence } from "motion/react";

interface InstructionCardProps {
  title: string;
  content: any;
}

const InstructionCard: React.FC<InstructionCardProps> = ({
  title,
  content
}) => {
  const [isOpen, setIsOpen] = React.useState(false);

  return (
    <div
      className="bg-white shadow-lg rounded-lg p-6 cursor-pointer flex gap-4 items-start"
      onClick={() => setIsOpen(!isOpen)}
    >
      <InfoCircleFilled className="text-3xl text-primary-blue mx-2" />

      <div className="flex-1">
        <h3
          className={`font-bold uppercase transition-all duration-300 ${
            isOpen ? "text-primary-blue mb-4" : "text-black"
          }`}
        >
          {title}
        </h3>

        <div
          className={`${
            isOpen ? "border-t-2" : ""
          } overflow-y-auto transition-all duration-700 mt-2`}
          style={{
            maxHeight: isOpen ? "999px" : "0px",
            scrollbarWidth: "thin"
          }}
        >
          {content}
        </div>
      </div>

      <div className={`rounded-full p-1 ${isOpen ? "bg-primary-blue/20" : ""}`}>
        <AnimatePresence mode="wait">
          {isOpen ? (
            <motion.div
              key="minus"
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.8 }}
              transition={{ duration: 0.1 }}
            >
              <Minus className="text-primary-blue min-w-5 min-h-5" />
            </motion.div>
          ) : (
            <motion.div
              key="plus"
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.8 }}
              transition={{ duration: 0.1 }}
            >
              <Plus className="text-primary-blue min-w-5 min-h-5" />
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </div>
  );
};

export default InstructionCard;
